module.exports = __webpack_public_path__ + "static/media/3.72d16abf.gif";